// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.signup-container .signup-logo {
  width: 130px;
  position: absolute;
  top: 50px;
  left: 50px;
}
.signup-container .email-row {
  font-size: 14px;
  color: #365A64;
}
.signup-container .signup-box-wrapper {
  padding: 20px;
}
.signup-container .signup-box-wrapper .signup-box {
  background-color: #fff;
  border-radius: 10px;
  width: 490px;
  display: flex;
  padding: 20px 0;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.signup-container .signup-box-wrapper .signup-box .signup-description {
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  color: #365A64;
  width: 330px;
  padding: 10px;
}
.signup-container .signup-box-wrapper .signup-box .signup-input {
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  padding: 14px;
  margin-bottom: 14px;
  width: 300px;
}
.signup-container .signup-box-wrapper .signup-box .signup-error {
  color: red;
  padding: 5px 0 20px 0;
  font-size: 13px;
}
.signup-container .signup-box-wrapper .signup-box .signup-button {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/SignUpPage/SignUpPage.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACF;AAEC;EACC,eAAA;EACA,cAAA;AAAF;AAGC;EACC,aAAA;AADF;AAGE;EACC,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AADH;AAGG;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AADJ;AAIG;EACC,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAFJ;AAKG;EACC,UAAA;EACA,qBAAA;EACA,eAAA;AAHJ;AAMG;EACC,eAAA;AAJJ","sourcesContent":[".signup-container {\n\tdisplay: flex;\n\theight: 100vh;\n\twidth: 100vw;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.signup-logo {\n\t\twidth: 130px;\n\t\tposition: absolute;\n\t\ttop: 50px;\n\t\tleft: 50px;\n\t}\n\n\t.email-row {\n\t\tfont-size: 14px;\n\t\tcolor: #365A64;\n\t}\n\n\t.signup-box-wrapper {\n\t\tpadding: 20px;\n\n\t\t.signup-box {\n\t\t\tbackground-color: #fff;\n\t\t\tborder-radius: 10px;\n\t\t\twidth: 490px;\n\t\t\tdisplay: flex;\n\t\t\tpadding: 20px 0;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-around;\n\t\t\talign-items: center;\n\n\t\t\t.signup-description {\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 17px;\n\t\t\t\tcolor: #365A64;\n\t\t\t\twidth: 330px;\n\t\t\t\tpadding: 10px;\n\t\t\t}\n\n\t\t\t.signup-input {\n\t\t\t\tborder: 1px solid #D3E1ED;\n\t\t\t\tborder-radius: 5px;\n\t\t\t\tpadding: 14px;\n\t\t\t\tmargin-bottom: 14px;\n\t\t\t\twidth: 300px;\n\t\t\t}\n\n\t\t\t.signup-error {\n\t\t\t\tcolor: red;\n\t\t\t\tpadding: 5px 0 20px 0;\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n\n\t\t\t.signup-button {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\t\t}\n\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
